import OverallDevelopmentTemplate from './template';
import OverallDevelopmentResult from './result';
import { Map } from 'immutable';

import {
  FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS,
  FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS,
} from './actions';

export default function OverallDevelopmentReducer(state = new Map({}), action) {
  switch (action.type) {
    case FETCH_OVERALL_DEVELOPMENT_RESULT_SUCCESS:
      return onFetchOverallDevelopmentResultSuccess(state, action);
    case FETCH_OVERALL_DEVELOPMENT_TEMPLATE_SUCCESS:
      return onFetchOverallDevelopmentTemplateSuccess(state, action);
    default:
      return state;
  }
}

function onFetchOverallDevelopmentTemplateSuccess(state, action) {
  const { idpId, payload } = action;
  if (payload) {
    let overallDevelopment = state.get(idpId) || new Map();
    const template = OverallDevelopmentTemplate.create(payload);
    overallDevelopment = overallDevelopment.set('template', template);
    return state.set(idpId, overallDevelopment);
  }
  return state;
}

function onFetchOverallDevelopmentResultSuccess(state, action) {
  const { idpId, payload } = action;
  if (payload) {
    let overallDevelopment = state.get(idpId) || new Map();
    const result = OverallDevelopmentResult.create(payload);
    overallDevelopment = overallDevelopment.set('result', result);
    return state.set(idpId, overallDevelopment);
  }
  return state;
}



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/OverallDevelopment/reducer.js